import { createContext, useContext } from 'react'

type CourseShellContextValue = {
  setPlayerActive: (active: boolean) => void
}

export const CourseShellContext = createContext<CourseShellContextValue>({
  setPlayerActive: () => {},
})

/** Lets CoursePlayer lock the shell to the viewport only while lessons play. */
export function useCourseShell() {
  return useContext(CourseShellContext)
}
